const imgUrl = {
  //'logo' : require('./covidkayalogo.png'),
  dohlogo: require("./dohlogo.png"),
  //'coughing' : require('./coughing.jpg'),
  //'loginPageImage' : require('./loginPageImage.jpg'),
  //'durelogowhite' : require('./durelogowhite.png'),
  addUser: require("./home/lightgreen/add-user.svg"),
  search: require("./home/lightgreen/search.svg"),
  alert: require("./home/lightgreen/alert.svg"),
  records: require("./home/lightgreen/records.svg"),
  referral: require("./home/lightgreen/referral.svg"),
  file_download: require("./home/lightgreen/file-download.svg"),
  file_upload: require("./home/lightgreen/file-upload.svg"),
  chatbot: require("./newloginpageicons/chatbot.png"),
  guide: require("./newloginpageicons/guide.png"),
  pdf: require("./newloginpageicons/pdf.png"),
  video_tutorial: require("./newloginpageicons/video-tutorial.png"),
  patientHome: require("./Patient.png"),
  "prov-home": require("./Provider.png"),
  back: require("../images/back.png"),
  clientImg: require("../images/customer.png"),
  transferImg: require("../images/transfer.png"),
  referalImg: require("../images/referral.png"),
  alertImg: require("../images/bell.png"),
  treatment: require("../images/calendar.png"),
  history: require("../images/medical-record.png"),
  user: require("../images/user.png"),
  chatbot: require("../images/chatbot.png"),
  //'icon':require('../images/icon.svg'),
  newprofile: require("../images/user.png"),
  linelist: require("../images/book.png"),
  client: require("../images/Client.png"),
  // carousel1: require("../images/carousel1.jpg"),
  // carousel2: require("../images/carousel2.jpg"),
  // carousel3: require("../images/carousel3.jpg"),
  // carousel4: require("../images/carousel4.jpg"),
  // carousel5: require("../images/carousel5.jpg"),
  // carousel6: require("../images/carousel6.jpg"),
  // carousel7: require("../images/carousel7.jpg"),
  // carousel8: require("../images/carousel8.jpg"),
  planindialogo: require("../images/PlanIndiaLogo.png"),
  swasthlogo: require("../images/SwasthLogo.png"),
  dpworldlogo: require("../images/DPWorldLogo.png"),
};

export default imgUrl;
